<template>
	<form class="search-form" v-on:submit.prevent="triggerSearch" v-click-outside="clearResults">
		<span class="search__icon icon"></span>
		<input
			class="search__field"
			:class="{ 'search__field-wide': searchText.length > 0 }"
			type="text"
			placeholder="Search"
			@input="onSearchText"
			v-model="searchText"
		/>
		<SearchSuggest
			v-if="results"
			:results="results"
			:searchPhrase="searchText"
			@resultselected="onResultSelected"
		/>
		<button
			class="search__clear icon"
			type="button"
			title="Clear text"
			v-if="searchText && searchText.length > 0"
			@click="clearText"
		></button>
		<button
			class="search__confirm icon"
			type="submit"
			title="Go to Search Page"
			v-if="searchText && searchText.length > 0"
		></button>
	</form>
</template>

<script>
import SearchSuggest from "./SearchSuggest";

export default {
	name: "SearchField",
	components: {
		SearchSuggest,
	},
	data: function () {
		return {
			searchText: "",
			results: null
		};
	},
	methods: {
		clearText: function () {
			this.searchText = "";
			this.results = null;
		},
		onResultSelected: function () {
			this.clearText();
		},
		clearResults: function () {
			this.results = null;
		},
		triggerSearch: function () {
			this.$router.push({ path: 'search-results', query: { search: this.searchText } });
			this.clearText();
		},
		onSearchText: function () {
			if (this.searchText.length === 0) {
				this.results = null;
				return;
			}
			if(this.searchText.length > 0) {
				this.results = this.$store.getters.filteredIndexArticles(this.searchText);
			}
		}
	},
};
</script>

<style scoped>

	.search-form {
		position: relative;
	}

	.search__field {
		width: 200px;
		padding: 0.5rem 1rem 0.5rem 2.6rem;
		transition: width 200ms;
		border: 1px solid var(--clr-neutral-shade-4);
		border-radius: var(--radius-border-main);
	}

	.search__field-wide,
	.search__field:focus {
		width: 400px;
		outline: none;
	}
	
	.icon {
		background-color: var(--clr-background);
		position: absolute;
		display: inline-flex;
		transform: translateY(-50%);
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		border: none;
	}

	.icon::before {
		display: block;
		font-family: "Font Awesome 6 Pro";
	}

	.search__icon {
		left: 5px;
		top: 50%;
	}

	.search__clear {
		right: 40px;
		top: 50%;
	}

	.search__confirm {
		right: 5px;
		top: 50%;
	}

	.search__clear::before {
		content: '\f00d';
	}

	.search__confirm::before {
		content: '\f061';
	}

	.search__icon::before {
		content: '\f002';
	}

</style>